<div class="threepl-services-settings-panel layout-column" appBringozIdGenerator="threepl-services-settings-panel">
  <div class="flex layout-column overflow-auto">

    <section>
      <bz-card [padded]="false" class="table-settings-header">
        <div class="layout-row layout-align-start-center pointer card-title">
          <span class="flex br-body-2 font-weight-400">{{ 'Table Columns' | translate }}</span>
          <span container="body" placement="left" [ngbTooltip]="'Show More' | translate">
            <bz-button variant="tertiary" size="fit"
                       appBringozIdGenerator="threepl-services-settings-columns-toggle-button"
                       [ariaLabel]="'Show More' | translate"
                       (clicked)="toggleSection('totalColumns')">
              <bz-icon [icon]="sections().totalColumns ? icons.collapse : icons.expand"></bz-icon>
            </bz-button>
          </span>
        </div>
        @if (sections().totalColumns) {
          <bz-divider></bz-divider>
          <div class="layout-row layout-wrap layout-align-start-center columns-container">
            @for (column of columnEntries(); track column.key) {
              <div class="flex-50 layout-row">
                <bz-switch appBringozIdGenerator="tableColumnSetting"
                           size="sm"
                           [checked]="column.enabled"
                           (checkedChange)="onChangeColumn(column.key, $event)">
                  <span class="br-body-2">{{ 'DELIVERIES_TABLE_COLUMNS.' + column.key | translate }}</span>
                </bz-switch>
              </div>
            }
          </div>
        }
      </bz-card>
    </section>

    @if (settings().dynamicColumns?.length) {
      <section>
        <bz-card [padded]="false" class="table-settings-header customized-columns" appBringozIdGenerator="threepl-services-settings-dynamic-columns">
          <div class="layout-row layout-align-start-center pointer card-title">
            <span class="flex br-body-2 gray-100">{{ 'Customized Table Columns' | translate }}</span>
            <span container="body" placement="left" [ngbTooltip]="'Show More' | translate">
              <bz-button variant="tertiary" size="fit"
                         appBringozIdGenerator="threepl-services-settings-dynamic-columns-toggle-button"
                         [ariaLabel]="'Show More' | translate"
                         (clicked)="toggleSection('dynamicColumns')">
                <bz-icon [icon]="sections().dynamicColumns ? icons.collapse : icons.expand"></bz-icon>
              </bz-button>
            </span>
          </div>
          @if (sections().dynamicColumns) {
            <bz-divider></bz-divider>
            <div class="layout-row layout-wrap layout-align-start-center columns-container">
              @for (column of settings().dynamicColumns; track column.key; let i = $index) {
                <div class="flex-50 layout-row">
                  <bz-switch appBringozIdGenerator="threepl-services-settings-dynamic-column-switch"
                             size="sm"
                             [checked]="!!column.enabled"
                             (checkedChange)="onDynamicColumnChange(i, $event)">
                    <span class="br-body-2">{{ column.title }}</span>
                  </bz-switch>
                </div>
              }
            </div>
          }
        </bz-card>
      </section>
    }

    <section>
      <bz-card [padded]="false" class="table-settings-header">
        <div class="layout-row layout-align-start-center card-title">
          <span class="flex br-body-2 font-weight-400">{{ 'View Settings' | translate }}</span>
          <span container="body" placement="left" [ngbTooltip]="'Show More' | translate">
            <bz-button variant="tertiary" size="fit"
                       appBringozIdGenerator="threepl-services-settings-view-toggle-button"
                       [ariaLabel]="'Show More' | translate"
                       (clicked)="toggleSection('viewSettings')">
              <bz-icon [icon]="sections().viewSettings ? icons.collapse : icons.expand"></bz-icon>
            </bz-button>
          </span>
        </div>
        @if (sections().viewSettings) {
          <div class="layout-row layout-align-start-center default-status-row">
            <span class="flex-60 br-body-2">{{ 'Default Status' | translate }}</span>
            <app-threepl-services-group-status-select class="flex"
                                                     [group]="settings().defaultGroup"
                                                     (groupChange)="onDefaultGroupChange($event)">
            </app-threepl-services-group-status-select>
          </div>
        }
      </bz-card>
    </section>

  </div>

  <bz-divider></bz-divider>

  <div class="layout-row layout-align-start-center padding-5">
    <bz-button variant="tertiary" appBringozIdGenerator="threepl-services-settings-cancel-button" (clicked)="onCancel()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <span class="flex"></span>
    <bz-button class="margin-right-5" variant="outline" tone="primary" appBringozIdGenerator="threepl-services-settings-reset-button"
               (clicked)="onReset()">
      {{ 'Reset' | translate }}
    </bz-button>
    <bz-button tone="secondary" appBringozIdGenerator="threepl-services-settings-submit-button" (clicked)="onSubmit()">
      {{ 'Submit' | translate }}
    </bz-button>
  </div>
</div>
